module.exports = __webpack_public_path__ + "assets/c2e094303185f3b4ef04c73f1fbd3ceb.png";